// Vendors
import React, { createContext, useContext, useMemo, useState } from 'react';
// Constants
import { LAYOUT_FOOTER_MODAL_COMPONENT_PROPS } from '../components/footer/components/modal/constants/layout-footer-modal.constants';
// Types
import {
  LayoutApiDataContextType,
  LayoutButtonContextType,
  LayoutCancelConfigurationType,
  LayoutContextType,
} from './types/layout.context.type';

const LayoutContext = createContext<LayoutContextType>({} as LayoutContextType);

const LayoutContextProvider = ({
  children,
}: {
  children: React.ReactElement;
}): React.ReactElement => {
  const [flowApiData, setFlowApiData] = useState<LayoutApiDataContextType>({});
  const [mainButtonConfiguration, setMainButtonConfiguration] = useState<LayoutButtonContextType>(
    {}
  );
  const [buttonGhostConfiguration, setButtonGhostConfiguration] = useState<LayoutButtonContextType>(
    {}
  );
  const [cancelModalConfiguration, setCancelModalConfiguration] =
    useState<LayoutCancelConfigurationType>({ ...LAYOUT_FOOTER_MODAL_COMPONENT_PROPS });
  const [compactView, setCompactView] = useState<boolean>(false);
  const [floatingFooter, setFloatingFooter] = useState<boolean>(false);
  const [hideStepper, setHideStepper] = useState<boolean>(false);
  const [hideFooter, setHideFooter] = useState<boolean>(false);
  const [relativeFooter, setRelativeFooter] = useState<boolean>(false);
  const [hideTitle, setHideTitle] = useState<boolean>(false);

  const contextValue = useMemo(
    () => ({
      buttonGhostConfiguration,
      cancelModalConfiguration,
      compactView,
      floatingFooter,
      relativeFooter,
      flowApiData,
      hideFooter,
      hideStepper,
      mainButtonConfiguration,
      hideTitle,
      setButtonGhostConfiguration,
      setCancelModalConfiguration,
      setCompactView,
      setFloatingFooter,
      setRelativeFooter,
      setFlowApiData,
      setHideFooter,
      setHideStepper,
      setMainButtonConfiguration,
      setHideTitle,
    }),
    [
      buttonGhostConfiguration,
      cancelModalConfiguration,
      compactView,
      floatingFooter,
      relativeFooter,
      flowApiData,
      hideFooter,
      hideStepper,
      mainButtonConfiguration,
      hideTitle,
      setButtonGhostConfiguration,
      setCancelModalConfiguration,
      setCompactView,
      setFloatingFooter,
      setRelativeFooter,
      setFlowApiData,
      setHideFooter,
      setHideStepper,
      setMainButtonConfiguration,
      setHideTitle,
    ]
  );

  return <LayoutContext.Provider value={contextValue}>{children}</LayoutContext.Provider>;
};

const useLayoutContextConsumerHook = (): LayoutContextType => useContext(LayoutContext);

/* eslint-disable */
const LayoutContextConsumerHOC =
  (Component: React.FC<any>) =>
  (props: React.PropsWithChildren<React.JSX.IntrinsicAttributes | any>) => (
    <LayoutContextProvider>
      <Component {...props} />
    </LayoutContextProvider>
  );

export { LayoutContextConsumerHOC, LayoutContextProvider, useLayoutContextConsumerHook };
